import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

// Re-initializes Bootstrap tooltips on connect, then removes itself.
// Use in turbo_stream responses that update tooltip content.
//
// Usage:
//   <div data-controller="turbo-reinit"
//        data-turbo-reinit-tooltips-value="true">
//   </div>
export default class TurboReinitController extends Controller {
  static values = {
    tooltips: { type: Boolean, default: false },
  };

  connect() {
    if (this.tooltipsValue) {
      document
        .querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach((el) => {
          new bootstrap.Tooltip(el);
        });
    }

    this.element.remove();
  }
}
